export { default as GDMAutocomplete } from './GDMAutocomplete';

export type { GDMAutocompleteComponent, GDMAutocompleteProps } from './GDMAutocomplete.type';
